import './App.css';
import LandingPage from './unAuth/components/landingpage';

function App() {
  return (
    <div className="App">
      <LandingPage />
    </div>
  );
}

export default App;
